require("!!/mnt/jenkins/jobs/master/workspace/node_modules/script-loader/addScript.js")(require("!!/mnt/jenkins/jobs/master/workspace/node_modules/raw-loader/index.js!/mnt/jenkins/jobs/master/workspace/core/client/vendor/modernizr.js"))


/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/vendor/modernizr.js
 **/